import * as React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import { translate } from 'react-i18next';
import Moment from 'react-moment';
import moment from 'moment';
import type { TranslatorProps } from 'react-i18next';
import { ComponentWithInjectedProps } from 'utils/injectedProps';

type TypeProps = {
  data: Object,
};

type InjectedProps = TranslatorProps;

@translate()
@observer
export default class AssetCalibrationDue extends ComponentWithInjectedProps<
  TypeProps,
  {},
  InjectedProps
> {
  @computed
  get asset() {
    // TODO: What if there is more than one asset? What if the contract is closed and therefore has no relationship with the asset?
    return this.props.data.assets[0] || {};
  }

  @computed
  get account() {
    // TODO: What if there is more than one asset? What if the contract is closed and therefore has no relationship with the asset?
    return this.asset.account || {};
  }

  getRentedAssetsTable() {
    const { t } = this.props;

    return {
      [`${t('general:trading_accounts.labels.name')}`]: this.account.name,
      [`${t('general:trading_accounts.labels.number')}`]: this.account.account_no,
      [`${t('general:assets.labels.number')}`]: this.asset.asset_number,
      [`${t('general:manufacturer')}`]: this.asset.manufacturer,
      [`${t('general:assets.labels.ml_product_type')}`]: this.asset.product_id,
      [`${t('general:model')}`]: this.asset.model,
      [`${t('general:description')}`]: this.asset.description,
      [`${t('general:assets.labels.options_fitted')}`]: this.asset.options_fitted,
      [`${t('general:assets.labels.serial_number')}`]: this.asset.serial_number,
    };
  }

  getCalibrationDueDate() {
    const { t } = this.props;
    const calDueDate = moment(this.asset.calibration_due_date).diff(moment(), 'days');

    return (
      <React.Fragment>
        <Moment date={this.asset.calibration_due_date} format="MMMM DD, YYYY" />
        <span>
          {` (${calDueDate} ${t('general:labels.day', {
            count: calDueDate,
          })})`}
        </span>
      </React.Fragment>
    );
  }

  getCalibrationDetailsTable() {
    const { t } = this.props;

    return {
      [`${t('general:calibrations.labels.last_calibrated')}`]: this.asset.last_calibrated,
      [`${t('general:calibrations.labels.due_date')}`]: this.getCalibrationDueDate(),
      [`${t('general:assets.labels.calibration_status')}`]: this.asset.calibration_status,
    };
  }

  renderTable(data: Object) {
    return (
      <table>
        <tbody>
          {Object.keys(data).map(key => {
            return (
              <tr key={key}>
                <td>
                  <b>{key}</b>
                </td>
                <td>{data[key]}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  render() {
    const { t } = this.props;

    return (
      <div>
        <h2>{t('general:assets.rented_assets.labels.details')}</h2>
        {this.renderTable(this.getRentedAssetsTable())}

        <h2>{t('general:calibrations.labels.details')}</h2>
        {this.renderTable(this.getCalibrationDetailsTable())}
      </div>
    );
  }
}
